import { UploadButton } from '@components/Button/UploadButton';
import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './FileUploader.module.scss';
import { FileInput } from './ui/FileInput/FileInput';

export type FileUploaderProps = {
  submitHandler: (data: FileFieldValue) => Promise<void>;
};

interface FileFieldValue extends FieldValues {
  file: File;
}

export function FileUploader({ submitHandler }: Readonly<FileUploaderProps>) {
  const { t } = useTranslation('common');

  const {
    handleSubmit,
    control,
    formState: { isLoading, isValid, isSubmitting },
  } = useFormContext<FileFieldValue>();

  return (
    <form
      id="detailsForm"
      name="detailsForm"
      onSubmit={handleSubmit((data) => submitHandler(data))}
      className={styles.root}
    >
      <div className={styles.uploadField}>
        <FileInput control={control} accept=".csv" />

        <UploadButton
          loading={isLoading || isSubmitting}
          disabled={isLoading || !isValid}
          startIcon={<FontAwesomeIcon icon={faArrowUpFromBracket} size="3x" />}
        >
          {t('fileUpload.upload')}
        </UploadButton>
      </div>
    </form>
  );
}
